import { createContext, useContext, useMemo, useState } from 'react';

import { ModalType } from '../types';

type DialogTypeHandlers = {
  resetDialogType: () => void;
  setBuyMoreDialog: () => void;
};

type DialogType = ModalType | null;

export const useDialogType = () => {
  const [type, setType] = useState<DialogType>(null);

  const handlers = useMemo<DialogTypeHandlers>(
    () => ({
      setBuyMoreDialog: () => setType(ModalType.BuyMore),
      resetDialogType: () => setType(null),
    }),
    []
  );

  return [type, handlers] as const;
};

export const ModalContext = createContext<{
  dialogType: DialogType;
  dialogTypeHandlers: DialogTypeHandlers;
}>({
  dialogType: null,
  dialogTypeHandlers: {} as DialogTypeHandlers,
});

export const useModalContext = (): {
  dialogType: DialogType;
  dialogTypeHandlers: DialogTypeHandlers;
} => useContext(ModalContext);
